module.exports = __webpack_public_path__ + "static/media/w-12.e12cc6b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/home/partners/images/w-12.jpg
// module id = 1872
// module chunks = 146